import React from "react"
import { AppAuthCheck } from "../../../Components/Common/AuthCheck/AppAuthCheck"
import { AIModelDetail } from "../../../Components/Views/Dashboard/Sections/AppDetail/AIModels/Prediction/AIModelDetail"
import { AppDetailRouteComponentProps } from "../../RouteProps"

export function AppModelDetailRoute({
    match
}: AppDetailRouteComponentProps<{
    modelID: string
}>) {
    return (
        <AppAuthCheck {...match.params} scope="ai:view">
            <AIModelDetail {...match.params} />
        </AppAuthCheck>
    )
}
